import { render, staticRenderFns } from "./ProcessInsights.vue?vue&type=template&id=58c88936&scoped=true"
import script from "./ProcessInsights.vue?vue&type=script&lang=js"
export * from "./ProcessInsights.vue?vue&type=script&lang=js"
import style0 from "./ProcessInsights.vue?vue&type=style&index=0&id=58c88936&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c88936",
  null
  
)

export default component.exports